;(function($){

    function Prospectus_history() {
        var _ = this;
        _.API = $("#app_url").val() + "/api/";

        $.ajaxSetup({
          headers:{
            'Accept' : "application/json",
            'Authorization': "Bearer "+$('meta[name="app-token"]').attr('content'),
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
        });        

        if($("#modal-prospectus-history").length > 0) {
            
            $("#modal-prospectus-history").iziModal({      
                bodyOverflow: true,
                closeOnEscape: false,
                overlayClose: false,
                history: false,
                autoOpen: false,
                onOpened: function(){
                    _.modal.stopLoading(); 
                },
                onOpening: function(modal){ 

                    _.modal = modal;

                    modal.startLoading();

                    _.html = '<form id="form-prospectus-history" enctype="multipart/form-data">'+
                   '<div class="row">' +
                        '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="text_prospectus_history">Descrição</label>' +
                                '<textarea name="text_prospectus_history" id="text_prospectus_history" rows="5"></textarea>' +
                                '<script src="'+$("#app_url").val()+'/vendor/ckeditor/ckeditor.js"></script>'+
                                '<script>'+
                                    'CKEDITOR.replace("text_prospectus_history", {'+
                                    'toolbar: ['+
                                        '{ name: "document", items: [ "Print"] },'+
                                        '{ name: "clipboard", items: [ "Undo", "Redo" ] },'+
                                        '{ name: "styles", items: [ "Format", "Font", "FontSize" ] },'+
                                        '{ name: "colors", items: [ "TextColor", "BGColor" ] },'+
                                        '{ name: "align", items: [ "JustifyLeft", "JustifyCenter", "JustifyRight", "JustifyBlock"] },'+
                                        '"/",'+
                                        '{ name: "basicstyles", items: [ "Bold", "Italic", "Underline", "Strike", "RemoveFormat", "CopyFormatting" ] },'+
                                        '{ name: "links", items: [ "Link", "Unlink" ] },'+
                                        '{ name: "paragraph", items: [ "NumberedList", "BulletedList", "-", "Outdent", "Indent", "-", "Blockquote" ] },'+
                                        '{ name: "insert", items: [ "Image", "Table" ] },'+
                                        '{ name: "tools", items: [ "Maximize" ] },'+
                                        '{ name: "editing", items: [ "Scayt" ] }'+
                                    '],'+
                                    'filebrowserImageUploadUrl :"'+$("#app_url").val()+'/ckeditor/images?_token='+$('meta[name="csrf-token"]').attr('content')+'",'+
                                    'uploadUrl:"'+$("#app_url").val()+'/ckeditor/images?_token='+$('meta[name="csrf-token"]').attr('content')+'&json",'+
                                    'extraPlugins:"uploadimage",'+
                                    'extraAllowedContent: "h3{clear};h2{line-height};h2 h3{margin-left,margin-top}",'+
                                    'height: 150,'+
                                    'removeDialogTabs: "image:advanced;link:advanced"'+
                                '});'+
                                '</script>' +
                            '</div>'+
                        '</div>'+                             
                   '</div>'+
                    '<div class="row">' +
                        '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                            '<div class="form-row">' +  
                                '<input type="hidden" id="prospectus_contacts_id" name="prospectus_contacts_id" value="'+_.prospectus_contacts_id+'">' + 
                                '<input type="hidden" id="users_id" name="users_id" value="'+_.users_id+'">' +                                                  
                                '<button class="pull-right btn-primary btn-send">Salvar <i class="fa fa-check-square" aria-hidden="true"></i></button>'+
                            '</div>'+
                        '</div>'+                             
                   '</div></form>';

                    if(_.html != "") {
                        $('#modal-prospectus-history').iziModal('setTitle', '<i class="fa fa-list-alt" aria-hidden="true"></i> Anotações');
                        $("#modal-prospectus-history .content").html(_.html);

                        _.myForm = $("#form-prospectus-history").validate({
                            rules: {
                                text_prospectus_history: { required: true },                            },
                            messages: {
                                text_prospectus_history: { required: "Campo Obrigatório" }
                            },
                            invalidHandler: function(e) {
                                
                                swal({
                                    title: "Atenção!",
                                    text: "Preencha todos os campos.",
                                    type: "warning",
                                    showCancelButton: false,
                                    confirmButtonColor: "#DD6B55",
                                    confirmButtonText: "OK!",
                                    closeOnConfirm: true
                                });

                            },
                            submitHandler: function( form ) {

                                for(instance in CKEDITOR.instances) {
                                    CKEDITOR.instances[instance].updateElement();
                                }

                                $("#form-prospectus-history .btn-send").html("Enviando...");
                                
                                $.ajax({
                                    type: "POST",
                                    url: _.API + "prospectos/anotacoes",
                                    cache: false,
                                    contentType: false,
                                    processData: false,
                                    data: new FormData(form),
                                    success: function(result)
                                    {
                                        $("#form-prospectus-history .btn-send").html("Enviar");

                                        form.reset();

                                        $('#modal-prospectus-history').iziModal('close'); 

                                        swal({
                                            title: result.message,
                                            text: "Click no botão para fechar!",
                                            type: "success",
                                            showCancelButton: false,
                                            confirmButtonColor: "#DD6B55",
                                            confirmButtonText: "Fechar!",
                                            closeOnConfirm: false
                                        }).then(function() {
                                          location.reload();
                                        });                                        
                                    },
                                    error: function(response) {
                                        var errors = $.parseJSON(response.responseText);
                                        
                                        $("#form-prospectus-history .btn-send").html("Enviar");

                                        swal({
                                            title: (errors.message) ? errors.message : "Ops! Houve um erro ao enviar. Tente novamente.",
                                            text: "Click no botão para fechar!",
                                            type: "warning",
                                            showCancelButton: false,
                                            confirmButtonColor: "#DD6B55",
                                            confirmButtonText: "Fechar!",
                                            closeOnConfirm: true
                                        });

                                        $myForm.showErrors(errors);   
                                    }
                                });
                            }
                        });
                    }               
                },
                onClosed: function() {
                    _.uri                    = null;
                    _.prospectus_contacts_id = null;
                    _.users_id               = null;
                    _.html                   = null;
                    _.myForm                 = null;
                    $("#modal-prospectus-history .content").html("");
                    $('#modal-prospectus-history').iziModal('setTitle', "");
                }        
            });
        }

        $("button.btn-create-prospectus-history").on("click", function(e){
            e.preventDefault();
            _.prospectus_contacts_id  = $(this).data('prospectus');
            _.users_id                = $(this).data('user');
            $('#modal-prospectus-history').iziModal('open');           
        });
    }     

   	new Prospectus_history();

}(jQuery));
 
 
 
 
